import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {UtilService} from './util-service';
import {GestaoPcaService} from './gestao-pca-service';
import {saveAs} from 'file-saver';

import {Observable} from 'rxjs';
import {FileService} from "./file-service";

@Injectable()
export class TomadaDeContaService {
  urlObterQuestoes: string;
  codigoModuloTomadaDeConta = 9;
  analiseAtual: any = null;
  idPaginaTomadaDeConta: string = "958";
  resumoAnalise: any;
  TIPO_ARQUIVO_TOMADA = 9;

  constructor(public http: HttpClient,
              private gestaoPcaService: GestaoPcaService,
              private utilService: UtilService,
              private fileService: FileService) {
  }

  public obterIdPaginaTomadaDeConta() {
    return this.idPaginaTomadaDeConta;
  }

  public obterListaAnalisesAnalista(): Observable<any> {
    this.urlObterQuestoes = "tomadaContaEspecial/listarAnalises?idPca=" + this.gestaoPcaService.getPCA().id + "&isJuridicionado=false";
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public obterListaAnalisesJuridicionado(): Observable<any> {
    this.urlObterQuestoes = "tomadaContaEspecial/listarAnalises?idPca=" + this.gestaoPcaService.getPCA().id + "&isJuridicionado=true";
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public listarTomadaDeConta(): Observable<any> {
    this.urlObterQuestoes = "tomadaContaEspecial/listar?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public listarAnalisesTomadaDeContaPrestacaoPendentes(): Observable<any> {
    this.urlObterQuestoes = "analiseTCEPrestacaoPendente/listar?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public listarAnalisesTomadaDeContaForaPrazo(): Observable<any> {
    this.urlObterQuestoes = "analiseTCEForaDoPrazo/listar?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public listarAnalisesTomadaDeContaNaoEnviadas(): Observable<any> {
    this.urlObterQuestoes = "analiseTCENaoEnviado/listar?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public obterPreviewCertificado(): Observable<any> {
    this.urlObterQuestoes = "tomadaContaEspecial/obterPreviewCertificado?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }


  public baixarTemplateTomadaDeConta() {
    let path = "tomadaContaEspecial/downloadTemplateImportacao";
    var headers = new HttpHeaders();
    headers.append('responseType', 'arraybuffer');
    this.utilService.getJSON(path)
      .subscribe(data => {
          let contentType = "data:" + data.mimeType + ";base64";

          let byteCharacters = atob(data.decodedFile);

          let byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);
          let file = new Blob([byteArray], {type: contentType});
          saveAs(file, "Template_importação_tomada_em_massa.xlsx");
        },
        error => console.log("Error downloading the file. error: " + error));
  }

  public listarFatoresGeradores(): Observable<any> {
    this.urlObterQuestoes = "tomadaContaEspecial/fatores";
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public submeterTomadaDeConta(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "tomadaContaEspecial/submterModulo?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public cargaMassa(event): Observable<any> {
    return this.fileService.cargaRelacaoTomadaDeContasEspeciais(event);
  }

  public salvarTomadaDeConta(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "tomadaContaEspecial/salvar?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public finalizarAnaliseTomadaDeConta(pIdModuloAnalise): Observable<any> {
    this.urlObterQuestoes = "tomadaContaEspecial/finalizarAnalise?idModuloAnalise=" + pIdModuloAnalise;
    return this.utilService.postJSON(this.urlObterQuestoes, "");
  }

  public deletarTomadaDeConta(idArquivo) {
    let urlObtencaoDados: string = "tomadaContaEspecial/deletar?id=" + idArquivo;
    return this.utilService.deleteJSON(urlObtencaoDados);
  }

  public deletarLista(jsonList, exclusaoTotal, idModuloAnalise): Observable<any> {
    this.urlObterQuestoes = "tomadaContaEspecial/deletarLista?exclusaoTotal="+ exclusaoTotal + "&idModuloAnalise=" + idModuloAnalise;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonList);
  }

  public salvarAnaliseTCEPendente(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseTCEPrestacaoPendente/salvar?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public finalizarAnaliseTCEPendente(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseTCEPrestacaoPendente/finalizar?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public salvarAnaliseTCEForaPrazo(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseTCEForaDoPrazo/salvar?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public finalizarAnaliseTCEForaPrazo(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseTCEForaDoPrazo/finalizar?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public salvarAnaliseTCENaoEnviado(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseTCENaoEnviado/salvar?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public finalizarAnaliseTCENaoEnviado(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseTCENaoEnviado/finalizar?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public importarDoAnoAnterior(idModuloAnalise): Observable<any> {
    this.urlObterQuestoes = "tomadaContaEspecial/importarPcaAnterior?idPca=" + this.gestaoPcaService.getPCA().id + "&idModuloAnalise=" + idModuloAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

}



// WEBPACK FOOTER //
// ./src/providers/tce-service.ts